/* Общие модалки сайта: «О бренде» и «Поддержка» открываются откуда угодно. */
import { createContext, useContext, useMemo, useState } from 'react';
import BrandModal from '../components/BrandModal.jsx';
import SupportModal from '../components/SupportModal.jsx';

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [modal, setModal] = useState(null);

  const value = useMemo(
    () => ({
      openBrand: () => setModal('brand'),
      openSupport: () => setModal('support'),
      close: () => setModal(null),
    }),
    [],
  );

  return (
    <UIContext.Provider value={value}>
      {children}
      {modal === 'brand' ? <BrandModal onClose={() => setModal(null)} /> : null}
      {modal === 'support' ? <SupportModal onClose={() => setModal(null)} /> : null}
    </UIContext.Provider>
  );
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error('useUI должен вызываться внутри UIProvider');
  return ctx;
}
